import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/meta-performance")({
  component: lazyRouteComponent(() => import("./-pages/admin.meta-performance")),
  head: () => ({
    meta: [
      { title: "Meta Performance · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
